module.exports = __webpack_public_path__ + "img/Dave.ecb86324.png";